import { useState } from 'react';
import { toast } from 'sonner';
import { Copy } from 'lucide-react';
import { Button } from '@/shared/components';

/**
 * Der Inhalt eines Vorgangs — lesbar formatiert oder unverändert, mit Kopieren-Aktion.
 *
 * Er steht bewusst auf heller Fläche in der Haupttextfarbe. Vorher lag er in einem gedimmten
 * Kasten mit rund 1,3:1 — der einzige Zweck dieses Fensters war nicht zu lesen (Befund aus D3).
 */
export function SyncActivityPayloadBlock({ raw, formatted }: { raw: string; formatted: string }) {
  const [showRaw, setShowRaw] = useState(false);
  const display = showRaw ? raw : formatted;

  function copy() {
    navigator.clipboard.writeText(display).then(
      () => toast.success('In die Zwischenablage kopiert'),
      () => toast.error('Kopieren ist fehlgeschlagen'),
    );
  }

  return (
    <div>
      <div className="mb-1.5 flex flex-wrap items-center justify-between gap-2">
        <div className="text-ink-faint mb-1.5 text-[10px] uppercase tracking-wider">Inhalt</div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setShowRaw((v) => !v)}
            aria-pressed={showRaw}
            className="text-ink-soft hover:text-ink inline-flex min-h-11 items-center text-[11px] uppercase tracking-wider"
          >
            {showRaw ? 'Lesbar zeigen' : 'Unformatiert zeigen'}
          </button>
          <Button
            variant="ghost"
            size="sm"
            onClick={copy}
            leftIcon={<Copy size={12} aria-hidden />}
          >
            Kopieren
          </Button>
        </div>
      </div>
      <pre className="border-line/40 bg-card-alt/40 text-ink max-h-100 overflow-auto rounded border p-3 text-xs">
        {display}
      </pre>
    </div>
  );
}
